import { render, staticRenderFns } from "./SessionObjectCardSingleAnswer.vue?vue&type=template&id=a71af87a&"
import script from "./SessionObjectCardSingleAnswer.vue?vue&type=script&lang=js&"
export * from "./SessionObjectCardSingleAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports